// var Preloader = require('../../../../../components/common/preloader.jsx');
// var LineChart = require('./line-chart-realtime.jsx');

// var InternalEventBus = require('../../../../../core/utils/internal-event-bus.js');
// var InternalEvent = require('../../../../../core/constants/internal-event.js');

import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import LineChartRealtime from "./lineChartRealtime.jsx";
import "!style!css!./styles.scss";

export default class AutoHedgeRealtime extends BaseComponent {
  constructor(props) {
    super(props);
    this.loadDependencies();
  }
  componentDidMount() {
    $('#dashboard-preloader').css('display', '');
    setTimeout(function () {
      this.autoHedgeBody = <LineChartRealtime onOrderClick={this.props.onOrderClick}/>;
      this.forceUpdate();
      //$('#dashboard-preloader').css('display', 'none');
      this.publish(InternalEvent.App.HIDE_PRELOADER);
    }.bind(this), 1500);// 1500
  }

  loadDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../../vendors/chartjs/Chart-1.0.2.js');
          resolve();
        });
      }
      catch(err) {
        reject(err);
      }
    });
  }

  render() {
    return (
      <div id="auto-hedge-container">
        {this.autoHedgeBody }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/auto-hedging-widget/autoHedgeRealtime.jsx